<template>
  <v-row>
    <v-col sm="6">
      <p class="chartLabel">Contas criadas</p>
      <AccountsChart
        :individualAccountsData="createdAccounts.individualAccountsData"
        :aggregateAccountsData="createdAccounts.aggregateAccountsData"
        :categories="createdAccounts.categories"
      />
    </v-col>
    <v-col sm="6">
      <p class="chartLabel">Contas bloqueadas</p>
      <AccountsChart
        :individualAccountsData="canceledAccounts.individualAccountsData"
        :aggregateAccountsData="canceledAccounts.aggregateAccountsData"
        :categories="canceledAccounts.categories"
      />
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import AccountsChart from "@/components/atoms/Contas/accounts-chart";

export default {
  components: {
    AccountsChart
  },
  data() {
    return {
      createdAccounts: {
        individualAccountsData: [
          this.totalIndividualAccountsCreatedInMonth(
            moment().subtract(2, "month")
          ),

          this.totalIndividualAccountsCreatedInMonth(
            moment().subtract(1, "month")
          ),

          this.totalIndividualAccountsCreatedInMonth(moment())
        ],
        aggregateAccountsData: [
          this.totalAggregateAccountsCreatedInMonth(
            moment().subtract(2, "month")
          ),

          this.totalAggregateAccountsCreatedInMonth(
            moment().subtract(1, "month")
          ),

          this.totalAggregateAccountsCreatedInMonth(moment())
        ],
        categories: [
          moment()
            .locale("pt-br")
            .subtract(2, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .subtract(1, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .format("MMMM")
        ]
      },
      canceledAccounts: {
        individualAccountsData: [
          this.totalIndividualAccountsBlockedInMonth(
            moment().subtract(2, "month")
          ),

          this.totalIndividualAccountsBlockedInMonth(
            moment().subtract(1, "month")
          ),

          this.totalIndividualAccountsBlockedInMonth(moment())
        ],
        aggregateAccountsData: [
          this.totalAggregateAccountsBlockedInMonth(
            moment().subtract(2, "month")
          ),

          this.totalAggregateAccountsBlockedInMonth(
            moment().subtract(1, "month")
          ),

          this.totalAggregateAccountsBlockedInMonth(moment())
        ],
        categories: [
          moment()
            .locale("pt-br")
            .subtract(2, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .subtract(1, "month")
            .format("MMMM"),
          moment()
            .locale("pt-br")
            .format("MMMM")
        ]
      }
    };
  },
  methods: {
    formatDate(value) {
      return moment(value, [
        "DD-MM-YYYY HH:mm:ss",
        "YYYY-MM-DDTHH:mm:ss.SSSSZ"
      ]);
    },
    totalIndividualAccountsCreatedInMonth(month) {
      return this.accounts.filter(account => {
        return (
          this.formatDate(account.createdAt) > month.startOf("month") &&
          this.formatDate(account.createdAt) < month.endOf("month") &&
          !(!account.isCompany && account.companyCnpj)
        );
      }).length;
    },
    totalAggregateAccountsCreatedInMonth(month) {
      return this.accounts.filter(account => {
        return (
          this.formatDate(account.createdAt) > month.startOf("month") &&
          this.formatDate(account.createdAt) < month.endOf("month") &&
          !account.isCompany &&
          account.companyCnpj
        );
      }).length;
    },
    totalIndividualAccountsBlockedInMonth(month) {
      return this.accounts.filter(account => {
        return (
          this.formatDate(account.blockedDate) > month.startOf("month") &&
          this.formatDate(account.blockedDate) < month.endOf("month") &&
          !(!account.isCompany && account.companyCnpj) &&
          account.blocked
        );
      }).length;
    },
    totalAggregateAccountsBlockedInMonth(month) {
      return this.accounts.filter(account => {
        return (
          this.formatDate(account.blockedDate) > month.startOf("month") &&
          this.formatDate(account.blockedDate) < month.endOf("month") &&
          !account.isCompany &&
          account.companyCnpj &&
          account.blocked
        );
      }).length;
    }
  },
  props: {
    accounts: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.chartLabel {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #212121;
}
</style>